/**
 * Only add constants here that are used across multiple files.
 */

export const JUSTIFICATION_MIN_CHARACTERS = 20;
export const OVERALL_FEEDBACK_ID = 'unified-feedback-overall-feedback';
